export default __webpack_public_path__ + "static/media/img-step-a-bg-2.06ff2943.jpg";